/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from '@angular/core';
import { EnvSettingsService } from 'src/app/core/services/env-settings.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User, UserWithRole } from 'src/app/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthPolicyService {
  private _adminApiRoute = '/api/V1/Admin';
  private _commonApiRoute = '/api/V1/Common';
  constructor(private _envSettings: EnvSettingsService, private _http: HttpClient) { }

  get adminServiceUrl() {
    return this._envSettings.getApiUrl() + this._adminApiRoute;
  }
  get commonServiceUrl() {
    return this._envSettings.getApiUrl() + this._commonApiRoute;
  }
  
  /*getUserRoles(): Observable<UserWithRole> {

    return this._http.get<UserWithRole>(this.adminServiceUrl + '/GetCurrentUserRoles'); 
  }*/

  getUserRoles(): Observable<any> {
      return this._http.get<any>(this.adminServiceUrl + '/GetUserRoleName'); 
  }

  isAdmin(): Observable<boolean> {
    return this._http.get<boolean>(this.adminServiceUrl + '/IsAdmin');
  }
  getUserDetails(): Observable<UserResponse> {
    return this._http.get<UserResponse>(this.adminServiceUrl + '/GetUserDetails');
  }
  userHasAccessToEvs(): Observable<boolean> {
    return this._http.get<boolean>(`${this.commonServiceUrl}/UserHasAccessToEvs`);
  }
}

export interface UserResponse {
  userDetails: UserDetails[];
  errorMessage?: string;
}

export interface UserDetails {
  userId: string;
  userName: string;
  email: string;
  title: string;
  companyCountryCode: string;
  modifiedBy: string;
  expirationStatus: Date;
  isAdminUser: boolean;
  isEvsUser: boolean;
  isReviewerUser: boolean;
  isUserDeActivated: boolean;
}
